import { useLang } from "../i18n/LanguageContext";
import { SHRINE_IMAGE } from "../assets/images";

export default function About() {
  const { t } = useLang();
  return (
    <div data-testid="about-page">
      <section className="container-page pt-20 sm:pt-28 pb-12">
        <div className="max-w-3xl">
          <div className="overline">{t.about.overline}</div>
          <h1 className="display-heading text-5xl sm:text-6xl mt-5 leading-[1.05]">
            {t.about.title}
          </h1>
          <span className="accent-rule mt-8 block" />
          <p className="mt-8 text-lg leading-relaxed text-[hsl(var(--muted-foreground))]">
            {t.about.lead}
          </p>
        </div>
      </section>

      <section className="container-page py-20 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <img src={SHRINE_IMAGE} alt="Santuário" className="w-full h-[480px] object-cover" />
          <div className="mt-6 border-l-2 border-[hsl(var(--accent))] pl-4">
            <div className="overline">{t.about.seatTitle}</div>
            <div className="mt-2 text-sm">{t.about.seatBody}</div>
            <div className="mt-3 text-xs uppercase tracking-[0.2em] text-[hsl(var(--muted-foreground))]">
              {t.about.mandate}
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 space-y-12">
          <div>
            <div className="overline">{t.about.historyTitle}</div>
            <p className="mt-4 leading-relaxed text-[hsl(var(--muted-foreground))]">{t.about.history}</p>
          </div>
          <div>
            <div className="overline">{t.about.missionTitle}</div>
            <p className="mt-4 leading-relaxed text-[hsl(var(--muted-foreground))]">{t.about.mission}</p>
          </div>
          <div>
            <div className="overline">{t.about.finalitiesTitle}</div>
            <ul className="mt-4 space-y-3">
              {t.about.finalities.map((f, i) => (
                <li key={i} className="flex gap-4">
                  <span className="text-[hsl(var(--accent))] font-semibold text-sm pt-0.5">
                    0{i + 1}
                  </span>
                  <span className="text-[hsl(var(--muted-foreground))] leading-relaxed">{f}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="bg-[hsl(var(--secondary))] py-20">
        <div className="container-page">
          <div className="overline">{t.about.foundersTitle}</div>
          <h2 className="display-heading text-3xl sm:text-4xl mt-4">9</h2>
          <span className="accent-rule mt-6 block" />
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-6">
            {t.about.founders.map((f, i) => (
              <div
                key={i}
                className="border-t border-[hsl(var(--border))] pt-4"
                data-testid={`founder-${i}`}
              >
                <div className="text-[10px] tracking-[0.22em] uppercase text-[hsl(var(--accent))]">
                  {String(i + 1).padStart(2, "0")} · {f.role}
                </div>
                <div className="mt-1.5 text-[hsl(var(--foreground))] leading-snug">{f.name}</div>
              </div>
            ))}
          </div>

          {t.about.spiritualAdvisorTitle && (
            <div className="mt-14 max-w-md" data-testid="spiritual-advisor">
              <div className="overline">{t.about.spiritualAdvisorTitle}</div>
              <div className="mt-3 pt-4 border-t-2 border-[hsl(var(--accent))] text-[hsl(var(--foreground))]">
                {t.about.spiritualAdvisor}
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
